import { jsonToQuery } from "../utils";
import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";

export const _ListCourseSubjects = async (searchData = false) => {
  let url = ServiceUrl.SUBJECTS.LIST_COURSE_SUBJECTS;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url);
};

export const _ListOldQuestionPapers = async (searchData = false) => {
  let url = ServiceUrl.SUBJECTS.LIST_OLD_QUESTION_PAPERS;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url);
};
